module.exports = __webpack_public_path__ + "static/11-2-9fb74554e81d71935b95371164ad2729.jpg";